import { ChevronRight, FileKey, Globe, Joystick, ScrollText, Settings, ShieldCheck } from "lucide-react";

// The PAM nav, defined once.
//
// It used to be two byte-identical copies (pamAccess.js and mfa/mfaPamNavigation.js)
// that had to be edited in lockstep. Both now build from here.
//
// Sections follow the capabilities PAM actually delivers rather than the
// screens that happen to exist:
//
//   Gateways    — the SSH proxies, their settings and their sessions
//   Targets     — the machines and the local accounts on them
//   Credentials — rotation and checkout
//   Policies    — who may reach what
//   Logs        — policy and auth events
//
// Removed rather than renamed: "SSH Proxy" (a one-time onboarding wizard pinned
// as a permanent destination — it is a button on the gateway list now) and
// "Connections" (the Guacamole-era credential-reveal screen, which nothing but
// this sidebar still reached). "My access" too: connecting is the Connect
// button on each endpoint, and /pam/myAccess redirects to the endpoint list.

const expand = ({ isOpen }) => (
  <ChevronRight className={`icon transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`} />
);

// One gateway, one word. The nav used to say "Jump Servers" and "SSH Proxy"
// for the same object while the detail page said "Gateway".
//
// Session Recordings is no longer listed here. Recordings are reached from the
// endpoint they belong to — the Endpoints table has a column per row — and from
// a gateway's own Sessions tab. The page itself still exists at
// /pam/jumpServer-sessionRecordings; seven places link into it.
export const gatewaysSection = {
  key: "/pam/jumpServer",
  icon: <Joystick className="icon" />,
  label: "Gateways",
  navigate: "/pam/jumpServer",
};

export const targetsSection = {
  key: "/pam/endpoint",
  icon: <Globe className="icon" />,
  label: "Targets",
  navigate: "/pam/endpoint",
  expandIcon: expand,
  children: [
    { key: "/pam/endpoint", label: "Endpoints", navigate: "/pam/endpoint" },
    { key: "/pam/endpointsUsers", label: "Endpoint Users", navigate: "/pam/endpointsUsers" },
    { key: "/pam/endpointGroups", label: "Endpoint Groups", navigate: "/pam/endpointGroups" },
  ],
};

// Hidden from the sidebar. The Password Rotation screen is gone and
// /pam/credentialRotation now redirects to the endpoint list; kept exported
// for when a Credentials section ships.
export const credentialsSection = {
  key: "/pam/credentialRotation",
  icon: <FileKey className="icon" />,
  label: "Credentials",
  navigate: "/pam/credentialRotation",
};

export const policiesSection = {
  key: "/pam/policy/v2",
  icon: <ShieldCheck className="icon" />,
  label: "Policies",
  navigate: "/pam/policy/v2",
};

// Settings is not in the sidebar: it lives in the account menu (top right).
// settingsSection stays exported for anything that still references it.

// One logs screen. "Logs → Auth Logs" was a parent with a single useful child;
// Policy Logs is not part of the PAM flow, so the section is flat.
//
// The policy-logs screen itself is NOT deleted — the Apps sidebar still lists
// it, and it stays reachable at /pam/policy-logs.
export const logsSection = {
  key: "/pam/auth-logs",
  icon: <ScrollText className="icon" />,
  label: "Access Logs",
  navigate: "/pam/auth-logs",
};

export const settingsSection = {
  key: "/pam/settings",
  icon: <Settings className="icon" />,
  label: "Settings",
  navigate: "/pam/settings",
};

export const PAM_SECTIONS = [
  gatewaysSection,
  targetsSection,
  policiesSection,
  // credentialsSection,  ← re-enable when Credentials ships
  logsSection,
];
